function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 12,
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 10,
  fill: "#FF8415"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M9 13v2H7v-2h2zm8 0v2h-6v-2h6zM9 9v2H7V9h2zm8 0v2h-6V9h6z"
}));

function SvgQMcNonscoredCompletedIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _ref);
}

export default SvgQMcNonscoredCompletedIcon;